var map = {
	"./advantages_1/1.svg": "0319",
	"./advantages_2/1.svg": "20c3",
	"./advantages_2/2.svg": "312e",
	"./advantages_2/3.svg": "0660",
	"./car_types/pickup.svg": "f737",
	"./car_types/sedan.svg": "1fb5",
	"./car_types/suv.svg": "211e",
	"./controls/ControlArrow1.svg": "32d4",
	"./controls/arrow2.svg": "21d6",
	"./logo.svg": "1ae4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0591";